import { Typography } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import NextImage from "common/bit/NextImage"
import styled from "styled-components"

const StyledSubtitle = styled(Typography).attrs({ variant: "subtitle1" })`
  color: #101010;
  margin-top: 20px;
`

const StyledText = styled(Typography).attrs({ variant: "body2" })`
  margin-top: 10px;
  color: #101010;
`

const StyledImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    gap: 20px;
  }
`
const StyledImageContainer = styled.div`
  overflow: hidden;
  margin-bottom: 20px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 0px;
  }
`
const StyledImage = styled(NextImage)`
  transition: 1s;
  :hover,
  :focus {
    transform: scale(1.2);
  }
`

type InnerContentTextProps = {
  title: string
  description: string[]
  images?: string[]
  imageSource?: string
}

const InnerContentText = ({
  title,
  description,
  images,
  imageSource,
}: InnerContentTextProps) => {
  const length = images?.length as number
  const isDesktop = useIsDesktop()
  return (
    <>
      <StyledSubtitle>{title}</StyledSubtitle>
      {description.map((text, index) => (
        <StyledText key={index}>{text}</StyledText>
      ))}
      <StyledImageWrapper>
        {images ? (
          images.map((image, index) => (
            <StyledImageContainer
              style={{
                width: isDesktop
                  ? length === 3
                    ? `${100 / 3}%`
                    : "50%"
                  : "100%",
                height: 300,
              }}
              key={index}
            >
              {/* <StyledImage
                src={image}
                alt="story"
                height={"300px"}
                loading="lazy"
                width={"100%"}
              /> */}
              <StyledImage image={{ imageUrl: image, alt: "story" }} />
            </StyledImageContainer>
          ))
        ) : (
          <StyledImageContainer
            style={{
              width: "100%",
              height: 400,
            }}
          >
            <StyledImage image={{ imageUrl: imageSource, alt: "brandStory" }} />
          </StyledImageContainer>
        )}
      </StyledImageWrapper>
    </>
  )
}

export default InnerContentText
